import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { getSession } from '../services/storage.service';

@Injectable()
export class NotLoggedInGuard implements CanActivate {
  constructor(
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const session = getSession();
    if (!!session && !!session.token) {
      this.router.navigate(['/home']);
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/guards/not-logged-in.guard.ts